import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/misc.service";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { catchError, exhaustMap, tap } from "rxjs/operators";
import { AuthService } from "../_services/auth.service";
import * as authActions from "./auth.actions";
import { MixpanelService } from "app/misc/mixpanel/mixpanel.service";

@Injectable({
  providedIn: "root",
})
export class AuthEffects {
  loginUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.loginUser),
      exhaustMap((action) =>
        this.authService.loginUser(action.credentials).pipe(
          tap((response: any) => {
            if (
              response?.role.toLowerCase() == "member" &&
              !response?.clusterPastor
            ) {
              this.toastr.error("You are not authorized to access this page");
              return of(
                authActions.loginUserFailed({
                  message: "You are not authorized to access this page",
                  code: 401,
                }),
              );
            }
            sessionStorage.setItem("xs_access_token", response.token);
            this.miscService.updateUser(response);
            this.mixpanelService.track("Login Successful", {
              email: response.email,
              buttonName: "Login",
              timestamp: new Date().toISOString(),
            });
            if (
              response?.role.toLowerCase() == "cell minister" &&
              !response?.clusterPastor
            ) {
              this.router.navigate(["/app/dashboard/reports/send-report"]);
              // this.toastr.error("You are not authorized to access this page");
              return;
            }
            this.router.navigate(["/app/dashboard/overview"]);

            // sessionStorage.setItem('session_id', response.adminPreferences.session_id);
            // this.storageManager.storeToStorage('user', response.data);
            // console.log(1,response);
          }),
          exhaustMap(() => [authActions.loginUserSuccessful()]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error?.error?.message);
            console.log("error", error);

            this.mixpanelService.track("Error Logging in", {
              email: action.credentials.identifier,
              buttonName: "Login",
              timestamp: new Date().toISOString(),
              error: error?.error?.message,
            });
            return of(
              authActions.loginUserFailed({
                message: error?.error?.message,
                code: error.status,
              }),
            );
          }),
        ),
      ),
    ),
  );

  forgotPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.forgotPassword),
      exhaustMap((action) =>
        this.authService.forgotPassword(action.email, action.source).pipe(
          tap((response: any) => {
            // this.storageManager.storeToStorage('ca-token', response.data);
          }),
          exhaustMap(() => [authActions.changePasswordSuccessful()]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error?.error?.message || "Network error");
            return of(
              authActions.changePasswordFailed({
                message: error?.error?.message,
                code: error.status,
              }),
            );
          }),
        ),
      ),
    ),
  );

  changePassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.changePassword),
      exhaustMap((action) =>
        this.authService.changePassword(action.email, action.payload).pipe(
          tap((response: any) => {}),
          exhaustMap(() => [authActions.changePasswordSuccessful()]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error?.error?.message || "Network error");
            return of(
              authActions.changePasswordFailed({
                message: error?.error?.message,
                code: error.status,
              }),
            );
          }),
        ),
      ),
    ),
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.logout),
      tap(() => {
        sessionStorage.clear();
        this.mixpanelService.logout();
        // sessionStorage.removeItem('access_token');
        // sessionStorage.removeItem('language');
        // sessionStorage.removeItem('loglevel');
        // sessionStorage.removeItem('user');
        // sessionStorage.removeItem('xs_access_token');
        this.router.navigate(["/auth"]);
      }),
      exhaustMap(() => []),
    ),
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private storageManager: AppLocalStorage,
    private toastr: ToastrService,
    private miscService: MiscService,
    private router: Router,
    private mixpanelService: MixpanelService,
  ) {}
}
